<template>
    <div id="`mmpsntaxbflist`">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('mmsetup.mmpsntaxbf'),
            dataHeader: [
                { text: this.$t('columns.actions'), value: 'action',  width: '80px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffno',  width: '120px'},
                { text: this.$t('columns.name'), value: 'name', width: '200px' },
                { text: this.$t('mmpsntaxbf.taxmonth'), value: 'months',  width: '80px'},
                { text: this.$t('mmpsntaxbf.taxperiod'), value: 'taxperiod', width: '80px' },
            ],

            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getThisListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/mmpsntaxbf/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'mmpsntaxbfedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'mmpsntaxbfnew'});
        }
    },

    mounted() {
        this.getThisListHandler();
    }
}
</script>